import { render, staticRenderFns } from "./BaseInputPhone.vue?vue&type=template&id=58d99ceb&scoped=true"
import script from "./BaseInputPhone.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseInputPhone.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BaseInputPhone.vue?vue&type=style&index=0&id=58d99ceb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d99ceb",
  null
  
)

export default component.exports